var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFullSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.15598 6.86329L9.32059 2.50311C9.59842 1.94338 10.4013 1.94338 10.6791 2.50311L12.8437 6.86329L17.6844 7.56679C18.3055 7.65705 18.553 8.41615 18.1034 8.85156L14.6013 12.2431L15.4278 17.0345C15.5339 17.6498 14.8843 18.119 14.3286 17.8284L9.99984 15.565L5.67106 17.8284C5.11534 18.119 4.46575 17.6498 4.57188 17.0345L5.39838 12.2431L1.8963 8.85156C1.44665 8.41615 1.69419 7.65705 2.31527 7.56679L7.15598 6.86329Z",
    fill: "#FFCA05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFullSmall);
export default __webpack_public_path__ + "static/media/star-full-small.8ccaaa2c5aee867777ccfb1624ed7ef6.svg";
export { ForwardRef as ReactComponent };